import axios from "axios";
const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
const BEARER_TOKEN = process.env.REACT_APP_API_TOKEN;
function fetchTrainings() {
    return axios.get(`/api/v1/trainings`,
        {
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${BEARER_TOKEN}` 
            },
        })
}

function fetchSessions() {
    return axios.get(`/api/v1/training_sessions`,
        {
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${BEARER_TOKEN}` 
            },
        })
}

function fetchSessionsById(id) {
    return axios.get(`/api/v1/training_sessions/` + id,
        {
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${BEARER_TOKEN}` 
            }
        })
}

function fetchTrainingById(id) {
    return axios.get(`/api/v1/trainings/` + id,
        {
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${BEARER_TOKEN}` 
            }
        })
}

function fetchModifTrainingById(id) {
    return axios.get(`https://backsc.osc-fr1.scalingo.io/api/formation/` + id, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

function postModifTraining(training) {
    console.log(training);
    return axios.post(
        'https://backsc.osc-fr1.scalingo.io/api/formations',
        {
            presentation: training.presentation,
            public: training.public,
            objectifs: training.goals,
            competence: training.competence,
            thematique: training.thematique,
            prix: String(training.cost),
            duree: String(training.duree),
            methode: training.methode,
            evaluation: training.evaluation,
            qualite: training.quality,
            nom: training.name,
            idForma: training.id,
            type: String(training.type),
            rating: training.rating,
            accessibility: training.accessibility,
            document: training.document,
            priceMulti: training.prixMax,
            groupes: training.groupes,
            groupesMax: training.groupesMax,
            qualification: training.qualification,
            cpf: training.cpf,
            prerequis: training.prerequis,
            ins_title: training.ins_title,
            ins_subtitle: training.ins_subtitle,
            ins_button: training.ins_button,
            ins_button_tel: training.ins_button_tel
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        }
    );
}

function putModifTraining(training) {
    console.log(training);
    return axios.put(
        'https://backsc.osc-fr1.scalingo.io/api/formations/' + training.idSecond,
        {
            presentation: training.presentation,
            public: training.public,
            objectifs: training.goals,
            competence: training.competence,
            thematique: training.thematique,
            prix: String(training.cost),
            duree: String(training.duree),
            methode: training.methode,
            evaluation: training.evaluation,
            qualite: training.quality,
            nom: training.name,
            idForma: training.id,
            type: String(training.type),
            rating: parseInt(training.rating, 10),
            accessibility: training.accessibility,
            document: training.document,
            priceMulti: training.prixMax,
            groupes: training.groupes,
            groupesMax: training.groupesMax,
            qualification: training.qualification,
            cpf: training.cpf,
            prerequis: training.prerequis,
            ins_title: training.ins_title,
            ins_subtitle: training.ins_subtitle,
            ins_button: training.ins_button,
            ins_button_tel: training.ins_button_tel
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        }
    );
}

function deleteModifTraining(training) {

    axios.delete(
        'https://backsc.osc-fr1.scalingo.io/api/formations/' + training.id,
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        }
    );
    setTimeout(() => {
        return axios.post(
            'https://backsc.osc-fr1.scalingo.io/api/formations',
            {
                presentation: training.description,
                public: String(training.conditions),
                objectifs: training.goals,
                competence: training.competences,
                prix: String(training.training_price),
                duree: String(training.duration),
                methode: training.methode,
                evaluation: training.eval,
                qualite: training.qualite,
                nom: training.name,
                id: training.id,
                accessibility: training.accessibility,
                type: String(training.training_cycle.id)
            },
            {
                headers: {
                    'Content-Type': 'application/ld+json',
                    'Accept': 'application/json, text/plain, */*'
                }
            }
        );
    }, 2000);


}

function postSessions(dateDebut, dateFin, link, id, location) {
    return axios.post(
        'https://backsc.osc-fr1.scalingo.io/api/sessions',
        {
            dateDebut: dateDebut,
            dateFin: dateFin,
            link: link,
            formation: "/api/formations/" + id,
            location: location
        },
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        }
    );
}


function fetchModifSessions(id) {
    return axios.get(`https://backsc.osc-fr1.scalingo.io` + id, {
        headers: {
            'Content-Type': 'application/ld+json',
            'Accept': 'application/json, text/plain, */*'
        }
    })
}

function deleteSession(id) {
    return axios.delete(
        'https://backsc.osc-fr1.scalingo.io/api/sessions/' + id,
        {
            headers: {
                'Content-Type': 'application/ld+json',
                'Accept': 'application/json, text/plain, */*'
            }
        }
    );
}

async function fetchDetailedSessions(id) {
    try {
        const response = await axios
            .get(`/api/v1/training_sessions/${id}/courses`, {
                headers: {
                    accept: 'application/json',
                    Authorization: `Bearer ${BEARER_TOKEN}` 
                }
            });
        return response.data;
    } catch (error) {
        console.error("Erreur lors de la récupération des sessions détaillées :", error);
        throw error; // Propage l'erreur pour qu'elle soit gérée en aval
    }
}

export default { fetchTrainings, fetchSessions, fetchSessionsById, fetchTrainingById, fetchModifTrainingById, postModifTraining, putModifTraining, deleteModifTraining, postSessions, fetchModifSessions, deleteSession, fetchDetailedSessions }
